import MuiIconButton, { IconButtonProps as MuiIconButtonProps } from '@mui/material/IconButton';

export type IconButtonProps = MuiIconButtonProps;

export const IconButton = (props: IconButtonProps) => {
  return <MuiIconButton {...props} disableRipple />;
};
